module.exports = __webpack_public_path__ + "img/pdf-book-blue.919818f6.png";